import React, { useContext, useEffect } from "react";
import { List, ListItem, IconButton } from "@material-ui/core";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useState } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AuthContext from "../../hooks/authContext";
import { useMediaQuery } from "@mui/material";

const ChildMenuItem = (props) => {
  const auth = useContext(AuthContext);
  const { tourAttr, item, index, handleDrawerToggle, change } = props;
  const [showChild, setShowChild] = useState(false);
  const location = useLocation();
  const [isShowBadge, setIsShowBadge] = useState(false);
  const isMobile = useMediaQuery('(max-width:767px)');

  const hasinnerChild =
    typeof item?.childItems !== "undefined" && item?.childItems?.length > 0
      ? true
      : false;
  const showChildMenu = (e) => {
    e.preventDefault();
    setShowChild(!showChild);
  };

  const handleLinkClick = () => {
    if(isMobile){
      if (handleDrawerToggle) {
        handleDrawerToggle();
      }
    }
  };

  const startTours = localStorage.getItem('startTour');
  useEffect(() => {
    if(startTours === "supplies"){
      setShowChild(true);
    }
  }, [location, startTours]);

  useEffect(() => {
    if (item?.childItems?.some(child => location?.pathname?.startsWith(child?.to))) {
      setShowChild(true);
    }
  }, [location.pathname, item?.childItems]);

  useEffect(() => {
    let showBadge = false;
    if (item.to === '/communications/message-board/live-chat') {
      if (!auth?.isReadPrivate || !auth?.isReadPublic) {
        showBadge = true;
      }
    } else if (item.to === '/supplies/cleaning/review') {
      if (auth?.pendingSupplyStatus?.length > 0) {
        showBadge = true;
      }
    } else if (item.to === '/supplies/cleaning/manage') {
      if (auth?.highPrioritySupply?.length > 0) {
        showBadge = true;
      }
    } else if (item.to === '/supplies') {
      if (auth?.pendingSupplyStatus?.length > 0 || auth?.highPrioritySupply?.length > 0) {
        showBadge = true;
      }
    } else if (item.to === '/operations/issues/manage') {
      if (auth?.issueCount > 0) {
        showBadge = true;
      }
    } else if (item.to === '/help/manageSupport') {
      if (auth?.pendingSupportStatus > 0) {
        showBadge = true;
      }
    }

    setIsShowBadge(showBadge);
  }, [auth.pendingSupplyStatus, auth?.pendingSupportStatus, auth.highPrioritySupply, auth.issueCount, auth.isReadPrivate, auth.isReadPublic, item.to]);


  const renderMenuChilditem = (item) => {
    return (
      showChild === true && (
        <List key={"subitem" + item} {...(tourAttr && { 'data-tour': tourAttr })} className={`submenuitems ${item?.childItems ? "w-[195px]" : "w-[180px]"}`}>
          {item?.childItems?.map((child, index) => {
            return <ChildMenuItem item={child} tourAttr={tourAttr} index={index} handleDrawerToggle={handleDrawerToggle}/>;
          })}
        </List>
      )
    );
  };

  return (
    <ListItem key={item.label + index} {...(tourAttr && { 'data-tour': tourAttr })}>
      {hasinnerChild === true ? (
        <>
          <div className="innerChildItemTitle">
            <Link onClick={showChildMenu} className={item?.classes ? item?.classes : ""} style={{fontWeight: item?.label === "Supplies" ? "normal" : "", paddingLeft: item?.label === "Supplies" ? "15px" : ""}} {...(tourAttr && { 'data-tour': tourAttr })}>
              {item?.icon && item.icon} {isShowBadge && <span className="absolute top-0 right-0 h-2 w-2 bg-[#fc8600] rounded-full InnerChildMenuBadgeIcon" />}
              <span className={change ? "ml-20" : ""}>{item.label}</span>
            </Link>
            <IconButton size="small" onClick={showChildMenu}>
              {showChild === true ? <KeyboardArrowDownIcon className="text-[#CBD5E1]"/> : <KeyboardArrowRightIcon className="text-[#CBD5E1]"/>}
            </IconButton>
          </div>
          {renderMenuChilditem(item)}
        </>
      ) : (
        <NavLink
          className={({ isActive }) => `child-nav-link ${item?.to === "/supplies/cleaning/review" || item?.to === "/supplies/cleaning/manage" ? "ph-30" : ""} ${isActive ? "active" : ""} ${item?.classes || ""}`}
          to={item.to}
          onClick={handleLinkClick}
          {...(tourAttr && { 'data-tour': tourAttr })}
        >
          {item?.icon && item.icon} <span className={change ? "ml-20" : ""}>{item.label}</span> 
          {`${item.isCountKey ? ' (' + auth.supplieStatusCount[item.isCountKey] + ')' : ''}`} 
          {isShowBadge && <span className={`absolute top-0 right-0 h-2 w-2 bg-[#fc8600] rounded-full ChildMenuBadgeIcon ${item?.to === "/supplies/cleaning/review" || item?.to === "/supplies/cleaning/manage" ? "right-5" : "right-6"}`} />}
        </NavLink>
      )}
    </ListItem>
  );
};

export default ChildMenuItem;
